import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [IconComponent],
  template: `
    <span class="ui-spinner" [class]="sizeClass()" role="status" [attr.aria-label]="label()">
      <app-icon name="loader" [size]="iconPx()" [decorative]="false" [label]="label()" />
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: var(--ui-spinner-color, var(--ui-color-primary));
    }
    .ui-spinner--sm {
      transform: scale(0.85);
    }
    .ui-spinner--lg {
      transform: scale(1.25);
    }
  `,
  host: {
    '[class.ui-spinner--sm]': 'size() === "sm"',
    '[class.ui-spinner--lg]': 'size() === "lg"',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  readonly size = input<'sm' | 'md' | 'lg'>('md');
  readonly label = input('Loading');

  protected iconPx(): number {
    switch (this.size()) {
      case 'sm':
        return 14;
      case 'lg':
        return 22;
      default:
        return 18;
    }
  }

  protected sizeClass(): string {
    return `ui-spinner--${this.size()}`;
  }
}
